import { useQuery } from '@tanstack/react-query';

import { SuggestedOpportunityView } from '@ndvr/customer-api';

import { CustomerApi } from 'API';

export const SuggestedOpportunityQueryKeys = {
    byNote: (noteGUID: string) => ['SuggestedOpportunities', noteGUID] as const,
} as const;

// Endpoint plus the by-note query it makes stale, so every dismiss caller invalidates the same key.
export const suggestedOpportunityDismissal = (suggestedOpportunityGUID: string, noteGUID: string) => ({
    request: () => CustomerApi().dismissSuggestedOpportunity(suggestedOpportunityGUID),
    staleQueryKey: SuggestedOpportunityQueryKeys.byNote(noteGUID),
});

export const useSuggestedOpportunitiesByNoteQuery = <TData = SuggestedOpportunityView[]>(
    noteGUID: string,
    options?: { select?: (suggestions: SuggestedOpportunityView[]) => TData },
) =>
    useQuery<SuggestedOpportunityView[], Error, TData>({
        enabled: !!noteGUID,
        queryKey: SuggestedOpportunityQueryKeys.byNote(noteGUID),
        queryFn: async () => {
            const [response] = await CustomerApi().getSuggestedOpportunitiesByNoteGUID({ noteGUID });
            return response ?? [];
        },
        ...options,
    });
